import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Titulo from './components/titulo';
import Seccion from './components/seccion';
import { getSeccionesFull } from './services/dbService';

import SeccionesContext from './context/seccionesContext';
import UsuarioContext from './context/usuarioContext';

import { contenidoStyle } from './styles/general';
import './App.css';

import { getOrCreateUsuario, getSeccionByCodigo, getSeccionesConContenido } from './utils/generales';

function App() {
  const [height, setHeight] = useState(0);
  const [usuario, setUsuario] = useState({});
  const [secciones, setSecciones] = useState([]);
  const [seccionesContenido, setSeccionesContenido] = useState([]);

  useEffect(() => {
    async function cargarAux(){
      const seccionesAux = await getSeccionesFull();
      const seccionesContenidoAux = getSeccionesConContenido(seccionesAux);
      const usuarioAux = await getOrCreateUsuario();
      setSecciones(seccionesAux);
      setSeccionesContenido(seccionesContenidoAux);
      setUsuario(usuarioAux);
    }
    if (secciones.length === 0){
      cargarAux();
    }
  }, [secciones])

  function cambiarVisiblidadSubsecciones (seccion, visible = true) {
    if (seccion.secciones && seccion.secciones.length > 0){
      for (let i = 0; i < seccion.secciones.length; i++ ){
        seccion.secciones[i].visible = visible ? !seccion.secciones[i].visible : visible;
        if (seccion.secciones[i].secciones && !seccion.secciones[i].visible){
          cambiarVisiblidadSubsecciones(seccion.secciones[i], false);
        }
      }  
    }
  }

  function handleCambiarNombreUsuario(nombre){
    setUsuario({...usuario, nombre});
  }

  function handleCambiarVisibilidadSeccion(seccion){
    const seccionesCambiadas = [...secciones];
    const { seccion: seccionCambiar } = getSeccionByCodigo(seccionesCambiadas, seccion.codigo);
    cambiarVisiblidadSubsecciones(seccionCambiar);
    setSecciones(seccionesCambiadas);
  }

  function handleAddLikeSeccion(seccion, idUsuario){
    const seccionesCambiadas = [...secciones];
    const { seccion: seccionCambiar } = getSeccionByCodigo(seccionesCambiadas, seccion.codigo);
    if (seccionCambiar.likes && seccionCambiar.likes.length){
      const like = seccionCambiar.likes.find(x => x === idUsuario);
      if (!like){
        seccionCambiar.likes.push(idUsuario);
      }
    } else {
      seccionCambiar.likes = [idUsuario];
    }
    setSecciones(seccionesCambiadas);
  }

  function handleRemoveLikeSeccion(seccion, idUsuario){
    const seccionesCambiadas = [...secciones];
    const { seccion: seccionCambiar } = getSeccionByCodigo(seccionesCambiadas, seccion.codigo);
    if (seccionCambiar.likes && seccionCambiar.likes.length){
      const like = seccionCambiar.likes.find(x => x === idUsuario);
      if (like){
        seccionCambiar.likes = seccionCambiar.likes.filter(x => x !== idUsuario);
      }
    }
    setSecciones(seccionesCambiadas);
  }

  const topContainer = (height || 0) + "px";
  return (
    <HelmetProvider>
      <Helmet>
        <title>Nicolas Barajas</title>
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://nicolasbarajas.netlify.app/logo192.png" />
        <meta property="og:description" content="¡Bienvenido a mi website!" />
      </Helmet>
      <UsuarioContext.Provider value={{usuario, onCambioNombreUsuario: handleCambiarNombreUsuario }}>
        <SeccionesContext.Provider value={{ secciones, seccionesContenido, onCambiarVisibilidadSeccion: handleCambiarVisibilidadSeccion, onAddLikeSeccion: handleAddLikeSeccion, onRemoveLikeSeccion: handleRemoveLikeSeccion }}>
          <div className="App">
            <BrowserRouter>
              <Titulo onSetHeight={setHeight} />            
              <div style={contenidoStyle(topContainer)}>
                  <Routes>
                    <Route path="/:cod" element={<Seccion/>}/>
                    <Route path="" element={<Navigate replace to="/inicio" />} />
                    <Route path="*" element={<Navigate replace to="/inicio" />} />
                  </Routes>
              </div>
            </BrowserRouter>
          </div>
        </SeccionesContext.Provider>
      </UsuarioContext.Provider>
    </HelmetProvider>
  );
}

export default App;
